import React from 'react';
import { useTranslation } from 'react-i18next';

interface Reason {
  title: string;
  text: string;
}

const WhyTreesSection: React.FC = () => {
  const { t } = useTranslation();
  const reasons = (t('why.reasons', { returnObjects: true }) as Reason[]) || [];
  const left = reasons.slice(0, 3);
  const right = reasons.slice(3, 6);

  return (
    <section id="why" style={{ background: '#fff', padding: '40px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
          <span className="section-tag">{t('why.subtitle', 'Почему это важно')}</span>
        </div>
        <h2 className="h2-center" style={{ marginBottom: 20 }}>
          {t('why.title')}
        </h2>

        <div className="grid-why">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {left.map((r, i) => (
              <ReasonCard key={i} reason={r} rotate={i === 1 ? -0.6 : 0} />
            ))}
          </div>

          <img
            src="/uploads/fig/why-plant.png"
            alt=""
            style={{ width: '100%', objectFit: 'contain' }}
          />

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {right.map((r, i) => (
              <ReasonCard key={i} reason={r} rotate={i === 1 ? 0.6 : 0} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const ReasonCard: React.FC<{ reason: Reason; rotate: number }> = ({ reason, rotate }) => (
  <div
    style={{
      background: '#DFEFCB',
      borderRadius: 20,
      padding: '20px 22px',
      transform: rotate ? `rotate(${rotate}deg)` : undefined
    }}
  >
    <div style={{ font: "600 16px 'Golos Text', sans-serif", color: '#2D5016' }}>
      {reason.title}
    </div>
    <div style={{ font: "400 14px/1.55 'Golos Text', sans-serif", color: '#5a6b4d', marginTop: 5 }}>
      {reason.text}
    </div>
  </div>
);

export default WhyTreesSection;
